module.exports = __webpack_public_path__ + "res/img/nosign.223de39b.png";